import script from "./Wecom.vue?vue&type=script&setup=true&lang=js"
export * from "./Wecom.vue?vue&type=script&setup=true&lang=js"

import "./Wecom.vue?vue&type=style&index=0&id=9dbf5a54&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dbf5a54"]])

export default __exports__